import React from 'react';
import { Section } from './Section';
import { Heart } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Menos hinchazón durante el día', 'Más ligereza en tu cuerpo', 'Menos pesadez después de comer', 'Más claridad sobre qué hacer y qué evitar', 'Más comodidad en tu ropa', 'Más control y menos frustración'];
  return <Section className="bg-forest text-cream" data-id="element-13">
      <div className="text-center mb-10" data-id="element-14">
        <Heart className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-15" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-16">
          Lo que esta guía puede ayudarte a sentir
        </h2>
      </div>
      <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-17">
        {benefits.map((benefit, index) => <div key={index} className="bg-forest-light p-6 rounded-xl border border-forest flex items-center gap-4" data-id="element-18">
            <div className="w-2 h-2 bg-gold rounded-full flex-shrink-0" data-id="element-19"></div>
            <p className="text-lg text-cream-dark font-medium" data-id="element-20">{benefit}</p>
          </div>)}
      </div>
    </Section>;
}